// extracted by mini-css-extract-plugin
export default {"time":"practice-times-schedule-overview-new-time_time__pCVs1","icon-container":"practice-times-schedule-overview-new-time_icon-container__ubisJ"};